import { HsVector2 } from '../../math-new/objects/vector2.class';
import type { HsControlActionType } from './control-action-type.enum';
import { HsControlAction } from './control-action.abstract';

export class HsMousePressedControlAction extends HsControlAction {
  constructor(
    public readonly actionType: HsControlActionType,
    public position: HsVector2 = new HsVector2(0, 0),
    isActive: boolean = false
  ) {
    super();
    this.isActive = isActive;
  }

  public getValuesFrom(controlAction: HsControlAction): void {
    if (!(controlAction instanceof HsMousePressedControlAction)) {
      return;
    }
    this.position.copy(controlAction.position);
    this.isActive = controlAction.isActive;
  }

  public override setInactive(): void {
    return;
  }
}
